/*
**************************************************************************
Title:          highlight directive
Created By:     Anshul Paliwal
Created on:     30/01/2021
Description:    Directive to highlight searched text.
**************************************************************************
*/

import { Directive, Input, SimpleChanges, Renderer2, ElementRef, OnChanges } from '@angular/core';

@Directive({
    selector: '[appHighlight]',
    standalone: false
})
export class HighlightDirective implements OnChanges {
  @Input() searchedWord: string; // searchText
  @Input() content: string; // list item
  @Input() classToApply = 'font-weight-bold'; // class to apply for highlighting


  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.content) {
      return;
    }

    if (!this.searchedWord || !this.searchedWord.length || !this.classToApply) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.content);
      return;
    }

    this.renderer.setProperty(
      this.el.nativeElement,
      'innerHTML',
      this.getFormattedText()
    );
  }

  // use regex to find & replace text including HTML class to highlight text.
  getFormattedText() {
    const re = new RegExp(`(${this.searchedWord})`, 'gi');
    return this.content.replace(re, `<span style=text-decoration:underline class="${this.classToApply}">$1</span>`);
  }
}
